import moment from "moment";
import _sortBy from "lodash/sortBy";
import _unionWith from "lodash/unionWith";
import { getServiceZoneByPoint } from "@/utils/business";
import { getServiceById } from "../utils/business";

export default {
  loggedIn(state) {
    return !!state.token;
  },
  tracking(state) {
    return state.tracking;
  },
  activeOrders(state) {
    const actives = state.orders.filter(
      (o) => !["completed", "canceled"].includes(o.status)
    );
    const lasts = state.orders.filter((o) =>
      moment(o.createdAt).isAfter(moment().subtract(1, "day"))
    );
    const orders = _unionWith(actives, lasts, (a, b) => a.id === b.id);
    return _sortBy(orders, (o) => -new Date(o.createdAt));
  },

  activeOrdersCompleted(state) {
    let completed = state.orders.filter(
      (o) =>
        !["programed", "canceled", "pending", "confirmed"].includes(o.status)
    );

    let listData = completed.reduce((obj, o) => {
      let time = moment(o.createdAt).format("yyyy-MM-DD");
      obj[time] = obj[time] + o.points.length || o.points.length;
      return obj;
    }, {});

    let data;
    const arrData = [];
    for (data in listData) {
      arrData.push({
        date: data,
        count: listData[data],
      });
    }

    return arrData;
  },
  countOrdersByMonthAndProgrammed(state) {
    let countsProgrammed = state.orders
      .filter((o) => o.service === "programmed")
      .reduce((obj, o) => {
        const time = moment(o.createdAt).format("MM/YY");
        obj[time] = ++obj[time] || 1;
        return obj;
      }, {});
    return countsProgrammed;
  },
  subTotalByMonth(state) {
    let completed = state.orders.filter(
      (o) =>
        !["programed", "canceled", "pending", "confirmed"].includes(o.status)
    );

    let subTotal = completed.reduce((obj, o) => {
      moment.locale("es");
      let time = moment(o.createdAt).format("MMMM-YY");
      obj[time] = obj[time] + o.amount || o.amount;
      return obj;
    }, {});

    let data;
    let arrData = [];
    for (data in subTotal) {
      arrData.push({
        month: data,
        amount: (subTotal[data] / 100.0).toFixed(2),
      });
    }

    arrData = arrData.slice(arrData.length - 12);
    return arrData;
  },

  newOrderStats({ newOrder }) {
    if (!newOrder) return null;
    const service = getServiceById(newOrder.service)
    const points = newOrder.points.map((p, i) => {
      const zone = getServiceZoneByPoint(newOrder.service, p);
      let price = 0;
      if (zone && i) {
        price = service.pricing[newOrder.vehicle].order.customer[zone.id - 1];
      }
      return {
        available: !!zone,
        price,
      };
    });

    const amount = points.reduce((a, p) => a + p.price, 0);

    return {
      points,
      amount,
    };
  },
  newExpressStats({ newExpress }) {
    if (!newExpress) return null;
    let points = newExpress.points.map((p) => {
      const zone = getServiceZoneByPoint(newExpress.service, p);
      return { available: !!zone };
    });
    return {
      points,
    };
  },
  newMercadoFlexStats({ newMercadoFlex }) {
    if (!newMercadoFlex) return null;
    const service = getServiceById("mercadoflex")
    let points = newMercadoFlex.points.map((p, i) => {
      const zone = getServiceZoneByPoint("mercadoflex", p);
      let price = 0;
      if (zone && i) {
        price = service.pricing[newMercadoFlex.vehicle].order.customer[zone.id - 1];
      }
      return {
        available: !!zone,
        price,
      };
    });

    const amount = points.reduce((a, p) => a + p.price, 0);

    return {
      points,
      amount,
    };
  },
};
